import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import GrainOverlay from './components/GrainOverlay';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Objects from './pages/Objects';
import Contact from './pages/Contact';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <GrainOverlay />
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/unternehmen" element={<About />} />
            <Route path="/planhaus" element={<About />} />
            <Route path="/leistungen" element={<Services />} />
            <Route path="/objekte" element={<Objects />} />
            <Route path="/kontakt" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
